import api from '@/services/api'
import denormalize from '@/utils/denormalizeResponse'
import { differenceWith, isEqual } from 'lodash'
import { EmbeddedPlayerLoader } from "../../../components/VideoPlayers/VideoPlaylist/EmbeddedPlayerLoader";
import { gql, gqlClient } from "@/services/gql";
import { setHasUploadedVideo } from "./mutations";

export async function fetchUrlSlug({ commit }, userId) {
    const response = await api.get(`/api/v2/resources/athletes/${userId}`, {
        query: {
            include: {
                "urlSlug": true,
            },
        },
    });
    const {
        root: {
            id,
        },
        resources: {
            athletes,
        },
    } = response;
    commit('setUrlSlug', athletes[id].urlSlug)
}


export async function getVideos({ commit }) {
    commit('toggleState', { prop: 'isLoading', toggleState: true });
    const response = await api.get(`/api/v2/me`, {
        query: {
            include: {
                "@fragments": ['athlete-profile:videos'],
                videos: {
                    "@paginate": {
                        limit: 2000,
                        offset: 0, //(page * 100) || 0
                    },
                },
            },
        },
    });
    const videos = denormalize(response);

    commit('toggleState', { prop: 'isLoading', toggleState: false });
    commit('toggleState', { prop: 'isAppending', toggleState: false });
    commit('loadVideos', videos.root.videos);
    commit('loadClips', Object.values(videos.resources.videoClips || {}));
    commit('loadProjects', videos.resources.videoProjects || {});
    commit('setUserId', response.root.id);
    commit('setFeaturedVideo');
}

export async function getPurchased({ state, commit }) {
    commit('toggleState', { prop: 'isLoading', toggleState: true });
    api.get("/api/v1/video/purchased").then(res => {
        state.events = res;
        commit('toggleState', { prop: 'isLoading', toggleState: false });
    }).catch((e) => {
        console.log(e);
    });
}

export async function getAvailable({ state, commit }) {
    commit('toggleState', { prop: 'isLoading', toggleState: true });
    api.get("/api/v1/video/available").then(res => {
        state.availableEvents = res;
        commit('toggleState', { prop: 'isLoading', toggleState: false });
    });
}

export async function toggleVisible({ commit, state }, { id, hardState }) {
    let video = state.videos.findIndex(video => video.id === id);
    let isVisible = state.videos[video].isVisible;
    let payload = { id, hardState, isVisible, video };

    if (hardState) {
        if (hardState.value === true) {
            await api.put(`/api/v2/videos/${id}/show`).catch(() => { });
            commit('toggleVisible', payload);
        }

        if (hardState.value === false) {
            await api.put(`/api/v2/videos/${id}/hide`).catch(() => { });
            commit('toggleVisible', payload);
        }

    } else {
        if (isVisible) {
            await api.put(`/api/v2/videos/${id}/hide`).catch(() => { });
            commit('toggleVisible', payload);
        } else {
            await api.put(`/api/v2/videos/${id}/show`).catch(() => { });
            commit('toggleVisible', payload);
        }
    }
}


export async function removeVideo({ commit, state }, id) {
    let video = state.videos.findIndex(video => video.id === id);
    state.videos.splice(video, 1);
    commit('setVideoSortOrder');
    return Promise.resolve();
}

export async function setSortOrder({ commit, state }) {
    let oldSortOrderAndIds = [];

    // Using For loops to eek out peformance gains for heavy computation.
    for (let i = 0; i < state.oldVideos.length; i++) {
        oldSortOrderAndIds.push({ videoId: state.oldVideos[i].id, sortOrder: state.oldVideos[i].sortOrder })
    }
    commit('setVideoSortOrder');
    let sortOrderAndIds = [];

    for (let j = 0; j < state.videos.length; j++) {
        sortOrderAndIds.push({ videoId: state.videos[j].id, sortOrder: state.videos[j].sortOrder })
    }
    // Only send the changed data
    let diff = differenceWith(sortOrderAndIds, oldSortOrderAndIds, isEqual)

    api.put('/api/v2/videos/order', { orderings: diff })
    return Promise.resolve()
}

export async function saveEdit({ commit }, { id, name, description, isHighlightReel }) {
    commit('toggleState', { prop: 'editSaving', toggleState: true })
    let res = await api.put(`/api/v2/videos/${id}/info`, {
        name,
        description,
        isHighlightReel
    });
    return res;
}
export async function setFeatured({ commit }, { video, reset = false }) {
    if (!reset) {
        api.put(`/api/v2/videos/feature`, {
            videoId: video.id,
        }).then(() => {
            commit('changeFeatured', video)
        });
    } else {
        api.put(`/api/v2/videos/feature`, {
            videoId: null,
        }).then(() => {
            commit('clearFeatured')
        });
    }
}

export async function fetchVideoPlaylist({ commit }, userId) {
    const response = await EmbeddedPlayerLoader.getVideoPlaylist(userId);

    commit('setVideoPlaylistId', response?.id);
    commit('setVideoPlaylistUrl', response?.embedUrl);
    commit('setVideoPlaylistName', response?.name);
    commit('setVideoPlaylistPublishedAt', response?.publishedAt);
    commit('setVideoPlaylistCreatedAt', response?.createdAt);
    commit('setVideoPlaylistIsLoaded', true);
}

export async function fetchUserHasUploadedVideo({ commit }) {
    const query = gql`
        query {
            me{
                player {
                    hasUploadedVideo
                    hasVideoPlaylists
                }
            }
        }
    `;

    const response = await gqlClient.query(query);

    commit('setHasUploadedVideo', response?.me?.player?.hasUploadedVideo || false)
    commit('setHasVideoPlaylists', response?.me?.player?.hasVideoPlaylists || false)
}
